import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { Filters } from './FiltersProvider';

type FiltersContextState = {
  search: string;
  setSearch: (search: string) => void;
  filters: Set<Filters>;
  toggleFilter: (filter: Filters) => void;
  clearFilters: () => void;
};

const defaultState = {
  search: '',
  setSearch: noop,
  filters: new Set<Filters>(),
  toggleFilter: noop,
  clearFilters: noop,
};

export const FiltersContext = createContext<FiltersContextState>(defaultState);

export const useFiltersContext = () => useContext(FiltersContext);
